function getUpgradeName (upgrade) {
  if (upgrade.status === 0) {
    return ''
  }
  if (upgrade.value === 0 || upgrade.value === 1) {
    return upgrade.skill
  }
  if (upgrade.value === 2) {
    return '+1 M'
  }
  if (upgrade.value === 3) {
    return '+1 Ar'
  }
  if (upgrade.value === 4) {
    return '+1 Ag'
  }
  if (upgrade.value === 5) {
    return '+1 F'
  }
}

function getUpgradeStyle (upgrade) {
  if (upgrade.type === 0) {
    return 'upgrade base'
  }
  if (upgrade.type === 1) {
    if (upgrade.value === 0) {
      return 'upgrade simple'
    }
    if (upgrade.value === 1) {
      return 'upgrade double'
    }
    if (upgrade.value > 1) {
      return 'upgrade stats'
    }
  }
}

function getDowngrades (player) {
  if (player.downgrades === null) {
    return ''
  }
  let dwngrd = ''
  if (player.downgrades['M'] !== 0) {
    dwngrd += '-' + player.downgrades['M'].toString(10) + 'M '
  }
  if (player.downgrades['F'] !== 0) {
    dwngrd += '-' + player.downgrades['F'].toString(10) + 'F '
  }
  if (player.downgrades['Ag'] !== 0) {
    dwngrd += '-' + player.downgrades['Ag'].toString(10) + 'Ag '
  }
  if (player.downgrades['Ar'] !== 0) {
    dwngrd += '-' + player.downgrades['Ar'].toString(10) + 'Ar '
  }
  return dwngrd
}

export default {
  getUpgradeName,
  getUpgradeStyle,
  getDowngrades
}



// WEBPACK FOOTER //
// ./src/common/team-helper.js